import { render, staticRenderFns } from "./MainNews.vue?vue&type=template&id=c1e848d8&scoped=true&"
import script from "./MainNews.vue?vue&type=script&lang=js&"
export * from "./MainNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e848d8",
  null
  
)

export default component.exports